import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import PropTypes from 'prop-types';
import styles from './style.module.css';
import Popover from '@mui/material/Popover';
import Box from '@mui/material/Box';
import {
  arrow_down,
  arrow_up,
  olsLocation,
  arrowDownBlack,
  arrowUpBlack,
  arrowDownWhite,
  arrowUpWhite,
} from 'assets/icons';
import { CircularProgress } from '@mui/material';
import BackButton from 'layouts/RegistrationLayoutNew/Buttons/BackButton';

const SelectPlanSection = ({
  selectedClub,
  newOlsPlans,
  selectedPlan,
  setSelectedPlan,
  gymHoursData,
  getGymHours,
  onNext,
  onBack,
  isMobile,
  isSmallMobile,
  membershipPlanInfo,
  resetArrayState,
  setSelectedPlanName,
  updateOlsTracking,
  trackingId,
  emailAddress,
  title,
  referralPerson,
  userExist,
  setTitle,
  titles,
  activePlanTab,
  setActivePlanTab,
}) => {
  const [isShowPlans, setShowPlans] = useState(false);
  const [selectedIndices, setSelectedIndices] = useState([]);
  const [anchorEl, setAnchorEl] = useState(null);
  const [todayHours, setTodayHours] = useState('');
  const history = useHistory();
  const currentLocation = window.location.pathname.substring(1).split('/')[0];

  const POLK_START_TODAY = 'Start Today';
  const POLK_START_GRAND_OPENING = 'Start Upon Grand Opening';

  const getPolkConfig = (name, isPolkGrandOpening) => {
    if (!name) return null;
    if (isPolkGrandOpening) {
      return {
        displayName: POLK_START_GRAND_OPENING,
        priceDescription: 'monthly recurring payment',
        planSubDescription: 'Fall 2026',
      };
    }
    if (name.includes('Polk Founding Member')) {
      return {
        displayName: POLK_START_TODAY,
        priceDescription: 'monthly recurring payment',
        planSubDescription: 'Access 8 Locations Today + Polk Upon Grand Opening',
      };
    }
    return null;
  };

  const oaklandPlanDescription = [
    'Access to Oakland',
    'Full Weight Floor & Cardio Deck',
    'Group Fitness Classes',
    'Full-Service Locker Rooms',
    'Towel Service',
    'Complimentary FIT Session',
  ];
  const marinPlanDescription = [
    'Access to Marin',
    'Full Weight Floor & Cardio Deck',
    'HydroMassage Beds & Massage Chairs',
    'Outdoor Gym',
    'Full-Service Locker Rooms',
    'Towel Service',
    'Free Parking',
    'Complimentary FIT Session',
  ];
  const allGymPlanDescription = [
    'Access to All Gyms',
    'Full Weight Floor & Cardio Deck',
    'Group Fitness Classes',
    'HydroMassage Beds & Massage Chairs',
    'Full-Service Locker Rooms',
    'Towel Service',
    'Pool, Sauna & Hot Tub <i>(Fillmore)</i>',
    'Free Parking <i>(Select Locations)</i>',
    'Complimentary FIT Session',
  ];
  const polkPlanDescription = [
    'Access to All Gyms',
    'Full Weight Floor & Cardio Deck',
    'Group Fitness Classes',
    'HydroMassage Beds & Massage Chairs',
    'Full-Service Locker Rooms',
    'Towel Service',
    'Red Light Therapy (Polk)',
    'Coworking (Polk)',
    'Dog Room (Polk)',
    'Pool, Sauna & Hot Tub <i>(Fillmore)</i>',
    'Free Parking <i>(Select Locations)</i>',
    'Complimentary FIT Session',
  ];
  const oneDayPassNote = 'Valid for use on the day of purchase';
  const extractFirstNumber = text => {
    const match = text.match(/\d+/);
    return match ? parseInt(match[0], 10) : null;
  };
  const generateValidityMessage = text => {
    const days = extractFirstNumber(text);
    return `Valid for ${days} consecutive days from the date of purchase`;
  };

  const handleClick = event => {
    if (anchorEl) {
      setAnchorEl(null);
    } else {
      setAnchorEl(event.currentTarget);
    }
  };

  const open = Boolean(anchorEl);
  const id = open ? 'schedule-popover' : undefined;

  // Close popover when scrolling
  useEffect(() => {
    const handleScroll = () => {
      if (anchorEl) {
        setAnchorEl(null);
      }
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [anchorEl]);

  useEffect(() => {
    if (Object.keys(gymHoursData).length !== 0) {
      const weekdays = [
        'Sunday',
        'Monday',
        'Tuesday',
        'Wednesday',
        'Thursday',
        'Friday',
        'Saturday',
      ];
      const today = new Date().getDay();
      const todayData = gymHoursData?.find(day => day.day === weekdays[today]);

      if (todayData) {
        setTodayHours(todayData.time);
      }
    }
  }, [gymHoursData]);

  const handleTabChange = tab => {
    setActivePlanTab(tab);
    if (tab === 'pass') {
      setTitle('Choose a pass');
    } else {
      setTitle(titles[1]);
    }
  };

  const handleBack = () => {
    resetArrayState('newOlsPlans');
    setShowPlans(false);
    onBack();
    history.push('/');
  };

  const handleTrackingApi = planName => {
    const data = {
      session: trackingId,
      email: emailAddress,
      currentPage: title,
      data: JSON.stringify({ membership: planName }),
      isFormerMember: userExist,
      isReferral: Object.keys(referralPerson).length !== 0,
      referrerName: Object.keys(referralPerson).length !== 0 ? referralPerson.name : null,
      referrerCaid:
        Object.keys(referralPerson).length !== 0 ? referralPerson?.caID : null,
    };
    updateOlsTracking(data);
  };

  const handleToggle = index => {
    if (selectedIndices.includes(index)) {
      setSelectedIndices(selectedIndices.filter(i => i !== index));
    } else {
      setSelectedIndices([...selectedIndices, index]);
    }
  };

  const handleSelectCard = (club, index) => {
    setSelectedPlan(club.id);
    const updatedPlanName =
      currentLocation === 'polk'
        ? club.displayName
        : activePlanTab === 'membership'
          ? club.selectedPlanName.replace(/\([^)]+\)/, '').split('-')[1]
          : club.selectedPlanName;
    setSelectedPlanName(updatedPlanName);
    // if (isMobile) {
    //   handleToggle(index);
    // }
  };

  const clubPlans = (Object.keys(membershipPlanInfo).length !== 0
    ? membershipPlanInfo.data.planData
    : newOlsPlans
  )
    .map(({ id, name, price, description, isDayPass, isPolkGrandOpening }) => {
      const type = name && name.toLowerCase().includes('month') ? 'monthly' : 'annually';
      const planName = name && name.replace(/\([^)]+\)/, '').split('-')[1];
      const formattedPrice = `$${price}`;
      const polkConfig = currentLocation === 'polk' ? getPolkConfig(name, isPolkGrandOpening) : null;
      const displayName = polkConfig ? polkConfig.displayName : planName;
      const priceDescription = polkConfig
        ? polkConfig.priceDescription
        : 'Billed on the 1st of each month';
      if (currentLocation === 'polk') {
        description = polkPlanDescription;
      } else if (
        planName?.includes('Oakland') ||
        (activePlanTab === 'pass' && currentLocation === 'oakland')
      ) {
        description = oaklandPlanDescription;
      } else if (
        planName?.includes('Marin') ||
        (activePlanTab === 'pass' && currentLocation === 'marin')
      ) {
        description = marinPlanDescription;
      } else {
        description = allGymPlanDescription;
      }
      return {
        id,
        isDayPass,
        isPolkGrandOpening,
        type,
        name: planName,
        displayName,
        priceDescription,
        planSubDescription: polkConfig?.planSubDescription || null,
        passPlanName: name,
        price: formattedPrice,
        description,
        selectedPlanName: name,
      };
    })
    .sort((a, b) => {
      const priceA = parseFloat(a.price.slice(1));
      const priceB = parseFloat(b.price.slice(1));
      return priceA - priceB;
    });

  const membershipPlans = clubPlans && clubPlans.filter(item => !item.isDayPass);

  const passPlans = clubPlans && clubPlans.filter(item => item.isDayPass);

  useEffect(() => {
    window.scrollTo(0, 0);
    if (activePlanTab === 'pass') {
      setTitle('Choose a pass');
    } else {
      setTitle(titles[1]);
    }
  }, []);

  useEffect(() => {
    const currentPlans = (Object.keys(membershipPlanInfo).length !== 0
      ? membershipPlanInfo.data.planData
      : newOlsPlans
    ).filter(el =>
      el.locationIds.some(
        i =>
          parseInt(i) ===
          (Object.keys(membershipPlanInfo).length !== 0
            ? parseInt(membershipPlanInfo.data.clubId)
            : +selectedClub?.clubautomationclubidC)
      )
    );

    if (currentPlans?.length > 0) {
      setShowPlans(true);
    } else {
      setShowPlans(false);
    }

    if (selectedClub?.clubautomationclubidC) {
      const selectedId = parseInt(selectedClub?.clubautomationclubidC);
      getGymHours(selectedId);
    }
  }, [selectedClub?.clubautomationclubidC, newOlsPlans, membershipPlanInfo]);

  return isShowPlans === true ? (
    <>
      <div className={`${styles.locationContainer} ${isMobile ? styles.mobile : ''}`}>
        <div
          onClick={() => handleBack()}
          style={{
            display: 'flex',
            cursor: 'pointer',
          }}
        >
          <img
            src={olsLocation}
            className={`${styles.locationIcon} ${isMobile ? styles.mobile : ''}`}
            alt=""
          />
          <p className={`${styles.locationText} ${isMobile ? styles.mobile : ''}`}>
            {selectedClub?.displayName}
          </p>
        </div>
      </div>
      <div className={styles.tabsContainer}>
        <div className={styles.tabs}>
          {/* Tab for "MEMBERSHIP" */}
          {activePlanTab === 'membership' ? (
            <button onClick={() => handleTabChange('membership')} className={styles.tab}>
              MEMBERSHIP
            </button>
          ) : (
            <p
              className={styles.inactiveTab}
              onClick={() => handleTabChange('membership')}
            >
              MEMBERSHIP
            </p>
          )}

          {/* Tab for "PASSES" */}
          {activePlanTab === 'pass' ? (
            <button
              onClick={() => {
                handleTabChange('pass');
              }}
              className={styles.tab}
            >
              PASSES
            </button>
          ) : (
            <p
              className={styles.inactiveTab}
              onClick={() => {
                handleTabChange('pass');
              }}
            >
              PASSES
            </p>
          )}
        </div>
      </div>
      {/* Content for each tab */}
      {activePlanTab === 'membership' ? (
        <div className={`${styles.body} ${isMobile ? styles.mobile : ''}`}>
          <div className={styles.wrapperContainer}>
            <div className={styles.descriptionContainer}>
              {currentLocation === 'polk' ? (
                <div className={styles.polkDescriptionWrapper}>
                  <p className={styles.polkFoundingTitle}>Become a Founding Member.</p>
                  <p className={styles.description}>
                    Help build the future of FITNESS SF Polk. Lock in your rate today and
                    be part of something exceptional from the very beginning.
                  </p>
                </div>
              ) : (
                <p className={styles.description}>
                  Become a FITNESS SF member and enjoy unlimited access, exclusive benefits,
                  and a supportive fitness community year-round!
                </p>
              )}
            </div>
          </div>
          <div className={styles.contentWrapper}>
            {membershipPlans.map((c, index) => (
              <>
                <div
                  className={`${styles.wrapper} ${selectedPlan === c.id}`}
                  key={c.id}
                  onClick={() => handleSelectCard(c, index)}
                >
                  <div
                    value={selectedPlan === c.id}
                    className={`
                ${styles.card} ${isMobile ? styles.mobile : ''}${
                      selectedIndices.includes(index) ? styles.expand : ''
                    } ${isSmallMobile ? styles.smallMob : ''}

                `}
                  >
                    <h1 className={`${styles.planName} ${
                        c.planSubDescription ? styles.planNameWithSub : ''
                      }`}
                    >
                      {c.displayName}
                      {c.planSubDescription && (
                        <span className={styles.planSubDescription}>
                          {c.planSubDescription}
                        </span>
                      )}
                    </h1>
                    <div className={styles.innerWrapper}>
                      <div className={styles.priceWrappper}>
                        <p
                          className={isMobile ? styles.planPriceMobile : styles.planPrice}
                        >
                          {c.price}
                          {!isMobile ? <span className={styles.priceText}>/mo</span> : ''}
                        </p>
                        <p className={styles.planPriceDescription}>
                          {c.priceDescription}
                        </p>
                      </div>
                      <div className={styles.SelectBtnWrapper}>
                        <button
                          onClick={() => {
                            onNext();
                            if (trackingId) {
                              handleTrackingApi(c.selectedPlanName);
                            }
                          }}
                          className={styles.selectBtn}
                        >
                          Select
                        </button>
                      </div>
                      {currentLocation === 'polk' &&
                        (c.displayName === POLK_START_TODAY ||
                          c.isPolkGrandOpening) && (
                        <div className={styles.polkAccessNote}>
                          <img src={olsLocation} className={styles.polkAccessIcon} alt="" />
                          <p className={styles.polkAccessText}>
                            {c.displayName === POLK_START_TODAY ? (
                              <>
                                Includes Polk access when it opens in{' '}
                                <span className={styles.polkHighlightDefault}>Fall 2026</span>.
                                Your membership updates automatically.
                              </>
                            ) : c.isPolkGrandOpening ? (
                              <>
                                Membership begins at{' '}
                                <span className={styles.polkHighlightBlack}>Grand Opening</span>{' '}
                                in <span className={styles.polkHighlightDefault}>Fall 2026</span>.
                                We'll confirm your start date as we get closer.
                              </>
                            ) : null}
                          </p>
                        </div>
                      )}
                      <div className={`${styles.descriptionWrapper}`}>
                        <h1 className={`${styles.descriptionHeading} ${currentLocation === 'polk' ? styles.descriptionHeadingPolk : ''}`}>
                          {c.name.includes('Premier') ? (
                            <>Includes All Gym Access, plus:</>
                          ) : (
                            <>Includes :</>
                          )}
                        </h1>
                        {currentLocation === 'polk' ? (
                          <ul className={styles.polkBulletList}>
                            {c.description.slice(0, 3).map((e, i) => (
                              <li key={i} dangerouslySetInnerHTML={{ __html: e }} />
                            ))}
                            {(!isMobile || selectedIndices.includes(index)) && (
                              <>
                                {c.description.slice(3).map((e, i) => (
                                  <li key={`rest-${i}`} dangerouslySetInnerHTML={{ __html: e }} />
                                ))}
                                <p className={styles.descriptionSubHeading}>Digital Features:</p>
                                <li>Nutrition <i>(by EatLove)</i></li>
                                <li>On-Demand Les Mills</li>
                              </>
                            )}
                          </ul>
                        ) : (
                          <p className={styles.descriptionPart1}>
                            {c.description.slice(0, 3).map(e => {
                              return (
                                <>
                                  {e} <br />
                                </>
                              );
                            })}
                          </p>
                        )}
                        <div
                          className={
                            isMobile && !selectedIndices.includes(index)
                              ? styles.toggleArrowDiv
                              : ''
                          }
                        >
                          {isMobile && !selectedIndices.includes(index) ? (
                            <div key={index} onClick={() => handleToggle(index)}>
                              <p>View More</p>
                              <img
                                src={arrow_down}
                                className={styles.toggleArrow}
                                alt=""
                              />
                            </div>
                          ) : null}
                        </div>
                        {currentLocation !== 'polk' && (
                          <p
                            className={`${styles.descriptionPart2} ${
                              isMobile ? styles.mobile : ''
                            } ${
                              isMobile && selectedIndices.includes(index) ? styles.show : ''
                            }`}
                          >
                            {c.description.slice(3, c.description.length).map(e => {
                              return (
                                <>
                                  <span dangerouslySetInnerHTML={{ __html: e }}></span>
                                  <br />
                                </>
                              );
                            })}
                            <p className={styles.descriptionSubHeading}>
                              Digital Features:
                            </p>
                            <p>
                              Nutrition{' '}
                              <span
                                dangerouslySetInnerHTML={{ __html: '<i>(by EatLove)</i>' }}
                              ></span>
                              <br />
                            </p>
                          </p>
                        )}
                        <div
                          className={
                            isMobile && selectedIndices.includes(index)
                              ? styles.toggleArrowDiv
                              : ''
                          }
                        >
                          {isMobile && selectedIndices.includes(index) ? (
                            <div key={index} onClick={() => handleToggle(index)}>
                              <p>View Less</p>
                              <img src={arrow_up} className={styles.toggleArrow} alt="" />
                            </div>
                          ) : null}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </>
            ))}
          </div>
        </div>
      ) : (
        <div className={`${styles.body} ${isMobile ? styles.mobile : ''}`}>
          <div className={styles.wrapperContainer}>
            <div className={styles.descriptionContainer}>
              <p className={styles.description}>
                Just Visiting or Dropping By? Enjoy full access to FITNESS SF with a 1-Day
                or 7-Day Pass—perfect for short stays or trying us out!
              </p>
            </div>
          </div>
          <div className={styles.dropdownContainer}>
            <p className={styles.hourText}>Today's Hours:</p>
            <span className={styles.select}>{todayHours}</span>
            <span onClick={handleClick}>
              <img
                src={open ? arrowUpBlack : arrowDownBlack}
                className={styles.downArrowIcon}
                alt=""
              />
            </span>
            <Popover
              id={id}
              open={open}
              anchorEl={anchorEl}
              disableScrollLock
              onClose={() => setAnchorEl(null)}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'center',
              }}
              transformOrigin={{
                vertical: 'top',
                horizontal: 'center',
              }}
              sx={{
                '& .MuiPaper-root': { borderRadius: '10px' },
              }}
            >
              <Box
                sx={{
                  width: '200px',
                  paddingTop: '18px',
                  paddingX: '15px',
                }}
              >
                {gymHoursData?.map((item, index) => (
                  <div key={index} className={styles.cardContainer}>
                    <p className={styles.day}>
                      <strong>{item.day}</strong>
                    </p>
                    <p className={styles.time}>{item.time}</p>
                  </div>
                ))}
              </Box>
            </Popover>
          </div>
          <div className={styles.contentWrapper}>
            {passPlans.map((c, index) => (
              <>
                <div
                  className={`${styles.wrapper} ${selectedPlan === c.id}`}
                  key={c.id}
                  onClick={() => handleSelectCard(c, index)}
                >
                  <div
                    value={selectedPlan === c.id}
                    className={`
                ${styles.passCard} ${isMobile ? styles.mobile : ''}${
                      selectedIndices.includes(index) ? styles.expand : ''
                    } ${isSmallMobile ? styles.smallMob : ''}

                `}
                  >
                    <h1 className={`${styles.passPlanName}`}>{c.passPlanName}</h1>
                    <div className={styles.innerWrapper}>
                      <div className={styles.passPriceWrappper}>
                        <p
                          className={
                            isMobile ? styles.passPlanPriceMobile : styles.passPlanPrice
                          }
                        >
                          {c.price}
                        </p>
                        <p className={styles.passPlanPriceDescription}>
                          {c.passPlanName.includes('1')
                            ? oneDayPassNote
                            : generateValidityMessage(c.passPlanName)}
                        </p>
                      </div>
                      <div className={styles.SelectBtnWrapper}>
                        <button
                          onClick={() => {
                            onNext();
                            if (trackingId) {
                              handleTrackingApi(c.selectedPlanName);
                            }
                          }}
                          className={styles.passSelectBtn}
                        >
                          Select
                        </button>
                      </div>
                      <div className={`${styles.descriptionWrapper}`}>
                        <h1 className={styles.passDescriptionHeading}>Includes :</h1>
                        <p className={styles.passDescriptionPart1}>
                          {c.description.slice(0, 3).map(e => {
                            return (
                              <>
                                {e} <br />
                              </>
                            );
                          })}
                        </p>
                        <div
                          className={
                            isMobile && !selectedIndices.includes(index)
                              ? styles.toggleArrowDiv
                              : ''
                          }
                        >
                          {isMobile && !selectedIndices.includes(index) ? (
                            <div key={index} onClick={() => handleToggle(index)}>
                              <p style={{ color: 'white' }}>View More</p>
                              <img
                                src={arrowDownWhite}
                                className={styles.toggleArrow}
                                alt=""
                              />
                            </div>
                          ) : null}
                        </div>
                        <p
                          className={`${styles.passDescriptionPart2} ${
                            isMobile ? styles.mobile : ''
                          } ${
                            isMobile && selectedIndices.includes(index) ? styles.show : ''
                          }`}
                        >
                          {c.description.slice(3, c.description.length).map(e => {
                            return (
                              <>
                                <span dangerouslySetInnerHTML={{ __html: e }}></span>
                                <br />
                              </>
                            );
                          })}
                          <p className={styles.descriptionSubHeading}>
                            Digital Features:
                          </p>
                          <p>
                            Nutrition{' '}
                            <span
                              dangerouslySetInnerHTML={{ __html: '<i>(by EatLove)</i>' }}
                            ></span>
                            <br />
                          </p>
                          {currentLocation === 'polk' && (
                            <p>
                              On-Demand Les Mills
                              <br />
                            </p>
                          )}
                        </p>
                        <div
                          className={
                            isMobile && selectedIndices.includes(index)
                              ? styles.toggleArrowDiv
                              : ''
                          }
                        >
                          {isMobile && selectedIndices.includes(index) ? (
                            <div key={index} onClick={() => handleToggle(index)}>
                              <p style={{ color: 'white' }}>View Less</p>
                              <img
                                src={arrowUpWhite}
                                className={styles.toggleArrow}
                                alt=""
                              />
                            </div>
                          ) : null}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </>
            ))}
          </div>
        </div>
      )}
      <BackButton
        onBack={() => handleBack()}
        backButtonName="Choose a different location"
      />
    </>
  ) : (
    <div className={styles.progressbarDiv}>
      <CircularProgress
        className={styles.circularProgress}
        style={{ color: '#fe5000' }}
      />
    </div>
  );
};

SelectPlanSection.propTypes = {
  selectedClub: PropTypes.string.isRequired,
  newOlsPlans: PropTypes.array.isRequired,
  selectedPlan: PropTypes.string.isRequired,
  setSelectedPlan: PropTypes.func.isRequired,
  onNext: PropTypes.func.isRequired,
};

SelectPlanSection.defaultValue = {
  newOlsPlans: [],
};

export default SelectPlanSection;
